import { render, staticRenderFns } from "./NextMoveInterestsQuestions.vue?vue&type=template&id=a5dbca90&scoped=true&"
import script from "./NextMoveInterestsQuestions.vue?vue&type=script&lang=ts&"
export * from "./NextMoveInterestsQuestions.vue?vue&type=script&lang=ts&"
import style0 from "./NextMoveInterestsQuestions.vue?vue&type=style&index=0&id=a5dbca90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5dbca90",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRadio,VRadioGroup,VRow})
